// extracted by mini-css-extract-plugin
export default {"card":"fg76jtaIlNs20p4hJgEt","card_image":"yls2rsgMEzQQoeSsHClf","card_body":"ZeqyGR2xc7wSXjHCFxYo"};